import React from 'react';
import pt from 'prop-types';

import { nl2br } from 'utils';

import Field from 'components/form/field';

import ConfirmModal from './Confirm';

export default class ConfirmRenameModal extends React.PureComponent {
  static propTypes = {
    title: pt.string,
    titleMessage: pt.any,
    loadingTitle: pt.string,
    nameInput: pt.object,
    message: pt.string,
    extraActions: pt.array,
    action: pt.string,
    actionType: pt.string,
    onConfirm: pt.func.isRequired,
    onCancel: pt.func,
  };

  nameValueRef = React.createRef();

  componentDidMount() {
    setTimeout(() => {
      if (this.nameValueRef.current) {
        this.nameValueRef.current.focus();
      }
    }, 500);
  }

  onConfirmInput = (_event) => {
    const { onConfirm } = this.props;
    const value = this.nameValueRef.current.value();
    return onConfirm(value);
  };

  render() {
    const {
      title,
      titleMessage,
      loadingTitle,
      onCancel,
      message = null,
      nameInput = null,
      action = 'Save',
      actionType = 'default',
      extraActions,
    } = this.props;

    return (
      <ConfirmModal
        title={titleMessage || `Rename ${title}`}
        width={650}
        message={
          <>
            {typeof message === 'string' ? (
              <p>{nl2br(message)}</p>
            ) : (
              message && message
            )}
            <Field
              ref={this.nameValueRef}
              label={nameInput?.label || 'Name'}
              required={true}
              {...(nameInput || undefined)}
            />
          </>
        }
        action={action}
        actionType={actionType}
        onConfirm={this.onConfirmInput}
        onCancel={onCancel}
        extraActions={extraActions}
        loadingTitle={loadingTitle}
      />
    );
  }
}
